import React, { useEffect, useRef, useState } from "react";
import { useParams } from "react-router";
import { useNavigate, useLocation } from "react-router-dom";

import { Stage, Layer, Circle } from "react-konva";

import { Skeleton } from "primereact/skeleton";

import { useQuery } from "react-query";
import { useAppContext } from "../../context/AppContext";
import { useMapContext } from "../../context/MapContext";
import { getMapImage } from "../../services/GlobalRoles/getMapImage";
import { getMapData } from "../../services/GlobalRoles/getMapData";
import { getPublicMapData } from "../../services/Public/getPublicMapData";
import { formatCurrency } from "../../utils/formatCurrency";
import noData from "../../assets/errors/noData.png";
import { Button } from "primereact/button";

const PublicMap = ({ empId, customAction, type }) => {
  const { hash, userId, role, token, appProfData, enterpriseId } = useParams();
  const { state } = useLocation();
  const navigate = useNavigate();
  const refId = hash;
  const decodedDataTeste = appProfData ? JSON.parse(atob(appProfData)) : null;
  // console.log({ hash, userId, role, token, appProfData, enterpriseId });
  // console.log({ decodedDataTeste });

  const { handleSetAppSidebarNone,
    handleSetAppHeaderNone,
    handleSetAppContentClass, permissions } = useAppContext();
  const {
    visibleTooltip,
    setVisibleTooltip,
    selectedItem,
    tooltipPosition,
    panX,
    panY,
    zoom,
    setCurrentBlock,
    setCurrentLandIndex,
    currentIndex,
    data,
    setData,
    items,
    setItems,
    updateCursorPosition,
    mouseX,
    mouseY,
    imageSize,
    processMapData,
    tooltipReverse,
    tooltipEnd,
    handleTapCircle
  } = useMapContext();

  // const { setTestId } = useContextSimulator();

  // const { nomenclatures } = useAppContext();
  // const nomenclature = JSON.parse(nomenclatures);

  const scrollRef = useRef();
  const [circleSize, setCircleSize] = useState(8);
  const [canvasWidth, setCanvasWidth] = useState(null);
  const [canvasHeight, setCanvasHeight] = useState(null);
  const [imageMap, setImageMap] = useState();
  const [mapImageMaps, setMapImageMaps] = useState();

  const { data: mapDataMaps, isLoading: loadingData } = useQuery({
    queryKey: [`map-data-${refId}`],
    queryFn: () => getPublicMapData(refId),
    retry: false,
  });

  useEffect(() => {
    handleSetAppSidebarNone(true);
    handleSetAppHeaderNone(true);
    handleSetAppContentClass("p-0");

    return () => {
      handleSetAppSidebarNone(false);
      handleSetAppHeaderNone(false);
      handleSetAppContentClass("");
    };
  }, [
    handleSetAppSidebarNone,
    handleSetAppHeaderNone,
    handleSetAppContentClass,
  ]);

  useEffect(() => {
    async function fetchData() {
      //      console.log(mapDataMaps);

      const { newItems, itemsToPosition } = processMapData(mapDataMaps);

      //      console.log("New Items: ", newItems);
      //      console.log("Items to: ", itemsToPosition);
      // Atualize os itens com os novos itens
      setItems([...newItems]);
      setData({ blocks: itemsToPosition });
      parseInt(mapDataMaps.ball_size) !== 0 && setCircleSize(parseInt(mapDataMaps.ball_size));
      // console.log("Items to Position: ", itemsToPosition);

      if (mapDataMaps.files[0]) {
        const imagem = new Image();
        imagem.src = mapDataMaps.files[0].path;
        imagem.onload = () => {
          const { largura, altura } = imageSize(imagem);
          setCanvasWidth(largura);
          setCanvasHeight(altura);
        };
        setImageMap(mapDataMaps.files[0].path);
      } else {
        return null;
      }
    }

    if (!loadingData) {
      fetchData();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [mapDataMaps]);

  return (
    <div>
      {loadingData && imageMap === undefined ? (
        <Skeleton width="100%" height="100vh" />
      ) : (
        <div style={{ overflowX: "scroll" }} ref={scrollRef}>
          {canvasWidth && items && (
            <div
              style={{
                position: "relative",
                width: "100%",
                transform: `scale(${zoom}) translate(${panX}px, ${panY}px)`,
              }}
            >
              {visibleTooltip && selectedItem && (
                <div
                  style={{
                    position: "absolute",
                    zIndex: "100",
                    minHeight: "100px",
                    pointerEvents: "none",
                  }}
                  className="map-instruction-desktop"
                >
                  <div
                    style={{
                      position: "relative",
                      left: tooltipPosition.left - 20, // Ajuste horizontal conforme necessário
                      // com imagem: top - 280
                      top: tooltipPosition.top - 150, // Ajuste o deslocamento vertical conforme necessário
                      fontSize: zoom > 1 ? "6px" : "16px",
                    }}
                    className="bg-white px-2 py-1 rounded"
                  >
                    <div className="d-flex flex-column">
                      <div className="d-flex">
                        <p className="mt-2 ms-2">
                          Quadra/Lote{" "}
                          <b>{selectedItem.land}</b>{" "}
                        </p>
                        <div
                          onClick={() => setVisibleTooltip(false)}
                          style={{ cursor: "pointer", pointerEvents: "auto" }}
                        >
                          <i
                            className="fa-regular text-danger fa-circle-xmark ms-4"
                            style={{ marginTop: "8px", fontSize: "20px" }}
                          ></i>
                        </div>
                      </div>
                      <div className="d-flex flex-column align-items-center mb-2">
                        <div className="d-flex">
                          <h6 className="mx-2">M²: {selectedItem.m2}</h6>
                          {selectedItem.color === "#33FF3C" && (
                            <h6 className="mx-2">
                              Valor: {formatCurrency(selectedItem.value)}
                            </h6>
                          )}
                        </div>

                        <div className="mt-2">
                          <Button
                            label={
                              selectedItem.color === "#33FF3C"
                                ? "Fazer Simulação"
                                : `Lote indisponível`
                            }
                            disabled={selectedItem.color !== "#33FF3C"}
                            onClick={() => {
                              // console.log({hash, userId, role, token, appProfData, enterpriseId});
                              navigate(`/publicSimulator/${hash}/${selectedItem.id}/${userId}/${role}/${token}/${appProfData}/${enterpriseId}`);
                            }
                            }
                            style={{ pointerEvents: "auto" }}
                          />
                        </div>
                      </div>
                    </div>
                    {window.innerWidth >= 992 && (
                      <div
                        style={{
                          position: "absolute",
                          top: !tooltipReverse ? "100%" : "", // Posicione o triângulo em relação à parte inferior do elemento pai
                          bottom: tooltipReverse ? "100%" : "",
                          left: tooltipEnd ? "90%" : "22px", // Centralize o triângulo horizontalmente
                          transform: tooltipReverse
                            ? "translateX(-50%) rotate(180deg)"
                            : "translateX(-50%)", // Centralize o triângulo horizontalmente
                          width: "0",
                          height: "0",
                          borderLeft: "10px solid transparent",
                          borderRight: "10px solid transparent",
                          borderTop: "10px solid white", // A cor do triângulo
                        }}
                        className="pin-map"
                      />
                    )}
                  </div>
                </div>
              )}
              <img
                src={imageMap}
                alt="map"
                style={{
                  width: canvasWidth,
                  height: canvasHeight,
                  position: "absolute",
                  objectFit: "contain",
                }}
                name={"map"}
              />
              <Stage
                width={canvasWidth}
                height={canvasHeight}
              >
                <Layer>
                  {items.map((item, i) => (
                    <Circle
                      key={i}
                      name={item.id.toString()}
                      x={item.x}
                      y={item.y}
                      radius={parseInt(circleSize)} // Tamanho fixo dos círculos
                      fill={item.color}
                      // onPointerClick={(e) => handleTapCircle(item, e, { x: 0, y: 0 })}
                      onPointerDown={(e) => handleTapCircle(item, e, { x: 0, y: 0 })}
                    />
                  ))}
                </Layer>
              </Stage>
            </div>
          )}
        </div>
      )}

      {/* window.innerWidth >= 992 ? (
          <div
            style={{
              position: "relative",
              width: "100%",
              transform: `scale(${zoom}) translate(${panX}px, ${panY}px)`,
            }}
          >
            {imageMap !== undefined ? (
              <img
                src={imageMap}
                alt="map"
                style={{
                  width: canvasWidth,
                  height: canvasHeight,
                  position: "absolute",
                  objectFit: "contain",
                }}
                name={"map"}
              />
            ) : (
              <Skeleton width="100%" height="100vh" />
            )}

            <Stage
              width={canvasWidth}
              height={canvasHeight}
              onMouseMove={updateCursorPosition}
            >
              <Layer>
                {items.map((item, i) => (
                  <Circle
                    key={i}
                    name={item.id.toString()}
                    x={item.x}
                    y={item.y}
                    radius={parseInt(circleSize)} // Tamanho fixo dos círculos
                    fill={item.color}
                    onPointerClick={(e) => handleTapCircle(item, e, { x: 0, y: 0 })}
                  />
                ))}
              </Layer>
            </Stage>
          </div>
        ) : (
          <div style={{ overflowX: "scroll" }} ref={scrollRef}>
            {canvasWidth && items && (
              <div
                style={{
                  position: "relative",
                  width: "100%",
                  transform: `scale(${zoom}) translate(${panX}px, ${panY}px)`,
                }}
              >
                <img
                  src={imageMap}
                  alt="map"
                  style={{
                    width: canvasWidth,
                    height: canvasHeight,
                    position: "absolute",
                    objectFit: "contain",
                  }}
                  name={"map"}
                />
                <Stage
                  width={canvasWidth}
                  height={canvasHeight}
                >
                  <Layer>
                    {items.map((item, i) => (
                      <Circle
                        key={i}
                        name={item.id.toString()}
                        x={item.x}
                        y={item.y}
                        radius={parseInt(circleSize)} // Tamanho fixo dos círculos
                        fill={item.color}
                        // onPointerClick={(e) => handleTapCircle(item, e, { x: 0, y: 0 })}
                        onPointerDown={(e) => handleTapCircle(item, e, { x: 0, y: 0 })}
                      />
                    ))}
                  </Layer>
                </Stage>
              </div>
            )}
          </div>
        ) */}

      {(!loadingData && !imageMap) && (
        <div className="d-flex flex-column justify-content-center align-items-center text-center">
          <img src={noData} alt="error" width="400px" />
          <h4>Não encontramos nenhum mapa por aqui</h4>
        </div>
      )}
    </div>
  );
};

export default PublicMap;
